// @flow

import * as React from 'react';
import {useIntl} from 'react-intl';
import {CompactTooltip} from 'sail/Tooltip';
import {ButtonLink} from 'sail/Button';
import {clipboard} from 'sail/Icon/Assets';
import {messages} from './messages';

type Props = {
  data: Object,
  className?: string,
};

const CopyAction = ({data, className}: Props) => {
  const {formatMessage} = useIntl();
  const [hasCopied, setHasCopied] = React.useState(false);
  const timeoutRef = React.useRef(null);

  React.useEffect(() => {
    if (hasCopied) {
      timeoutRef.current = setTimeout(() => {
        setHasCopied(false);
      }, 1000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [hasCopied]);

  const handleCopy = (e) => {
    e.stopPropagation();
    const stringifiedData =
      typeof data === 'string' ? data : JSON.stringify(data, null, 2);
    navigator.clipboard
      .writeText(stringifiedData)
      .then(() => setHasCopied(true));
  };

  return (
    <span className={className}>
      <CompactTooltip
        variableWidth
        context={
          <ButtonLink
            icon={clipboard}
            onClick={handleCopy}
            label={formatMessage(
              hasCopied ? messages.copiedLabel : messages.copyLabel,
            )}
            hideLabel
          />
        }
        label={formatMessage(
          hasCopied ? messages.copiedLabel : messages.copyLabel,
        )}
      />
    </span>
  );
};

export default CopyAction;
